// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.country-page {
  padding: 120px 0 80px;
  background: var(--bg-white);
  color: var(--text-dark-gray);
}

.country-page-inner {
  max-width: 860px;
}

.country-breadcrumb {
  margin-bottom: 1.25rem;
  color: var(--footer-medium-gray);
}

.country-breadcrumb a {
  color: var(--primary-dark-blue);
  text-decoration: none;
}

.country-page h1,
.country-heading {
  font-size: 2.2rem;
  line-height: 1.4;
  margin-bottom: 1rem;
  color: var(--primary-dark-blue);
  position: relative;
  padding-bottom: 0.85rem;
}

.country-heading::after {
  content: '';
  position: absolute;
  inset-inline-start: 0;
  bottom: 0;
  height: 4px;
  width: 0;
  border-radius: 999px;
  background: var(--gradient-maritime);
  animation: underlineGrow 0.9s var(--motion-ease) 0.15s forwards;
}

.country-intro,
.country-page p {
  line-height: 1.9;
  margin-bottom: 1rem;
}

.country-page h2 {
  margin: 2rem 0 1rem;
  font-size: 1.4rem;
  color: var(--primary-dark-blue);
}

.country-crossings {
  list-style: none;
  padding: 0;
  margin: 0;
  line-height: 2;
}

.country-crossings li {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
  padding: 0.55rem 0.75rem;
  border-radius: 10px;
  background: linear-gradient(90deg, rgba(14, 116, 144, 0.06), transparent 70%);
}

.country-list-dot {
  width: 10px;
  height: 10px;
  margin-top: 0.7rem;
  border-radius: 50%;
  flex-shrink: 0;
  background: var(--secondary-light-gold);
  box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.45);
  animation: listDotPulse 2s ease-in-out infinite;
}

@keyframes listDotPulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.35);
  }
  50% {
    box-shadow: 0 0 0 8px rgba(212, 175, 55, 0);
  }
}

.country-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin: 2rem 0;
}

.country-actions-top {
  margin: 0 0 1.5rem;
}

.country-related {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.85rem;
}

.country-related-card {
  display: block;
  padding: 1rem 1.1rem;
  border-radius: 12px;
  background: var(--bg-white);
  border: 1px solid var(--border-light);
  box-shadow: 0 6px 18px var(--shadow-color);
  color: var(--primary-dark-blue);
  font-weight: 600;
  text-decoration: none;
}

.country-related a:not(.country-related-card) {
  display: inline-block;
  padding: 0.55rem 0.9rem;
  border-radius: 999px;
  background: var(--section-light-gray);
}

.country-hero-figure {
  margin: 0 0 1.5rem;
  border-radius: 12px;
  overflow: hidden;
  background: var(--section-light-gray);
}

.country-hero-image {
  display: block;
  width: 100%;
  height: auto;
  max-height: 420px;
  object-fit: cover;
}

.region-card-image {
  display: block;
  width: 100%;
  height: 140px;
  object-fit: cover;
  border-radius: 8px 8px 0 0;
  margin: -0.25rem -0.25rem 0.85rem;
  width: calc(100% + 0.5rem);
}

.region-card {
  overflow: hidden;
}

@media (max-width: 768px) {
  .country-page {
    padding: 100px 0 60px;
  }

  .country-page h1,
  .country-heading {
    font-size: 1.7rem;
  }
}

@media (prefers-reduced-motion: reduce) {
  .country-heading::after {
    animation: none;
    width: 100%;
  }

  .country-list-dot {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/CountryPage.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,WAAW;EACX,QAAQ;EACR,oBAAoB;EACpB,oCAAoC;EACpC,+DAA+D;AACjE;;AAEA;;EAEE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;EACnB,6EAA6E;AAC/E;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,uCAAuC;EACvC,4CAA4C;EAC5C,+CAA+C;AACjD;;AAEA;EACE;;IAEE,4CAA4C;EAC9C;EACA;IACE,2CAA2C;EAC7C;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;EAC3B,qCAAqC;EACrC,0CAA0C;EAC1C,+BAA+B;EAC/B,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,0BAA0B;EAC1B,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE;IACE,qBAAqB;EACvB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,eAAe;IACf,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".country-page {\n  padding: 120px 0 80px;\n  background: var(--bg-white);\n  color: var(--text-dark-gray);\n}\n\n.country-page-inner {\n  max-width: 860px;\n}\n\n.country-breadcrumb {\n  margin-bottom: 1.25rem;\n  color: var(--footer-medium-gray);\n}\n\n.country-breadcrumb a {\n  color: var(--primary-dark-blue);\n  text-decoration: none;\n}\n\n.country-page h1,\n.country-heading {\n  font-size: 2.2rem;\n  line-height: 1.4;\n  margin-bottom: 1rem;\n  color: var(--primary-dark-blue);\n  position: relative;\n  padding-bottom: 0.85rem;\n}\n\n.country-heading::after {\n  content: '';\n  position: absolute;\n  inset-inline-start: 0;\n  bottom: 0;\n  height: 4px;\n  width: 0;\n  border-radius: 999px;\n  background: var(--gradient-maritime);\n  animation: underlineGrow 0.9s var(--motion-ease) 0.15s forwards;\n}\n\n.country-intro,\n.country-page p {\n  line-height: 1.9;\n  margin-bottom: 1rem;\n}\n\n.country-page h2 {\n  margin: 2rem 0 1rem;\n  font-size: 1.4rem;\n  color: var(--primary-dark-blue);\n}\n\n.country-crossings {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  line-height: 2;\n}\n\n.country-crossings li {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 0.65rem;\n  padding: 0.55rem 0.75rem;\n  border-radius: 10px;\n  background: linear-gradient(90deg, rgba(14, 116, 144, 0.06), transparent 70%);\n}\n\n.country-list-dot {\n  width: 10px;\n  height: 10px;\n  margin-top: 0.7rem;\n  border-radius: 50%;\n  flex-shrink: 0;\n  background: var(--secondary-light-gold);\n  box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.45);\n  animation: listDotPulse 2s ease-in-out infinite;\n}\n\n@keyframes listDotPulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 rgba(212, 175, 55, 0.35);\n  }\n  50% {\n    box-shadow: 0 0 0 8px rgba(212, 175, 55, 0);\n  }\n}\n\n.country-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin: 2rem 0;\n}\n\n.country-actions-top {\n  margin: 0 0 1.5rem;\n}\n\n.country-related {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.85rem;\n}\n\n.country-related-card {\n  display: block;\n  padding: 1rem 1.1rem;\n  border-radius: 12px;\n  background: var(--bg-white);\n  border: 1px solid var(--border-light);\n  box-shadow: 0 6px 18px var(--shadow-color);\n  color: var(--primary-dark-blue);\n  font-weight: 600;\n  text-decoration: none;\n}\n\n.country-related a:not(.country-related-card) {\n  display: inline-block;\n  padding: 0.55rem 0.9rem;\n  border-radius: 999px;\n  background: var(--section-light-gray);\n}\n\n.country-hero-figure {\n  margin: 0 0 1.5rem;\n  border-radius: 12px;\n  overflow: hidden;\n  background: var(--section-light-gray);\n}\n\n.country-hero-image {\n  display: block;\n  width: 100%;\n  height: auto;\n  max-height: 420px;\n  object-fit: cover;\n}\n\n.region-card-image {\n  display: block;\n  width: 100%;\n  height: 140px;\n  object-fit: cover;\n  border-radius: 8px 8px 0 0;\n  margin: -0.25rem -0.25rem 0.85rem;\n  width: calc(100% + 0.5rem);\n}\n\n.region-card {\n  overflow: hidden;\n}\n\n@media (max-width: 768px) {\n  .country-page {\n    padding: 100px 0 60px;\n  }\n\n  .country-page h1,\n  .country-heading {\n    font-size: 1.7rem;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .country-heading::after {\n    animation: none;\n    width: 100%;\n  }\n\n  .country-list-dot {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
